// ManagementListPage.jsx
import React from "react";
import MgmtTable from "./Table/MgmtTable";
import LoadingCircle from "../../../../../../components/LoadingCircle";
import ListPageHeader from "../../../../../../components/Tables/ListPageControls/ListPageHeader";
import FadeTransition from "../../../../../../components/FadeTransition";
import ViewModal from "../Modal/ViewModal";
import AlertSnackbar from "../../../../../../components/Notifications/AlertSnackbar";
import PaginationContainer from "./PaginationContainer";
import { useSelector } from "react-redux";
import { selectLoading } from "../../../../../../redux/mgmtCo/managementSlice";
import { selectAllCompanies } from "../../../../../../redux/mgmtCo/managementSlice";
import useListPage from "../../hooks/useListPage";
import useExport from "../../../../../../hooks/useExport";

const ManagementListPage = () => {
  const loading = useSelector(selectLoading);
  const companies = useSelector(selectAllCompanies); // full list of management companies
  // Use the management-specific list hook.
  const {
    setSearchQuery,
    isViewOpen,
    setIsViewOpen,
    listExpanded,
    setListExpanded,
    snackbar,
    handleSnackbarClose,
    handleAddAndView,
    handleOpenAddFromView,
    handleDeleteSelected,
    updateList,
    sortField,
    order,
    handleSort,
  } = useListPage();

  // Use the export hook.
  const { exportToCSV } = useExport();

  // Define export handler for management companies.
  const handleExport = () => {
    // Export the complete list from Redux. Adjust the filename as needed.
    exportToCSV(companies, "management_companies.csv");
  };

  return (
    <div className="flex flex-col h-full min-h-0 relative">
      {/* Main Content Section */}
      <div className="flex-1 min-h-0 overflow-auto relative bg-gray-50">
        <FadeTransition show={loading}>
          <LoadingCircle />
        </FadeTransition>
        <FadeTransition show={!loading}>
          <div
            className={`transition-all duration-300 ${
              listExpanded ? "w-full" : "w-11/12"
            } mx-auto px-10`}
          >
            {/* Header Section */}
            <ListPageHeader
              title="Management Companies: "
              onAdd={handleAddAndView}
              toggleFilterModal={() => {}}
              deleteSelected={handleDeleteSelected}
              onSearch={(value) => setSearchQuery(value)}
              isExpanded={listExpanded}
              setIsExpanded={() => setListExpanded(!listExpanded)}
              onExport={handleExport} // Pass export handler here
            />
            {/* Table Section */}
            <MgmtTable
              handleOpenViewModal={(company) => setIsViewOpen(true)}
              expanded={listExpanded}
              sortField={sortField}
              order={order}
              handleSort={handleSort}
            />
          </div>
        </FadeTransition>
      </div>
      {/* Footer Section */}
      <PaginationContainer />
      {/* Modals */}
      <ViewModal
        open={isViewOpen}
        handleClose={() => setIsViewOpen(false)}
        handleOpenAddFromView={handleOpenAddFromView}
        updateList={updateList}
      />
      {/* Snackbar Notification */}
      <AlertSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={handleSnackbarClose}
      />
    </div>
  );
};

export default ManagementListPage;
